module.exports = __webpack_public_path__ + "images/apple_store.png";


//////////////////
// WEBPACK FOOTER
// ./project/client/src/site__mhf/images/apple_store.png
// module id = /tool/node_modules/file-loader/dist/cjs.js??ref--2-0!/tool/node_modules/img-loader/index.js??ref--2-1!/tool/project/client/src/site__mhf/images/apple_store.png
// module chunks = site__mhf